import {EXTERNAL_ROUTES, ROUTES} from "../../../libs/routing";

export type FooterNavOption = {
  label: string;
  children: {
    label: string;
    link?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  }[];
};

export const useFooterNav = (): {
  config: FooterNavOption[];
} => {
  return {
    config: [
      {
        label: 'Platform',
        children: [
          {
            label: 'Why Powerlead',
            link: ROUTES.WHY_POWERLEAD,
          },
          {
            label: 'Chrome Extension',
            link: EXTERNAL_ROUTES.EXTENSION_MARKET,
            target: '_blank',
          },
          {
            label: 'Pricing',
            link: ROUTES.PRICING,
          },
        ],
      },
      {
        label: 'Company',
        children: [
          {
            label: 'About Powerlead',
            link: ROUTES.ABOUT,
          },
          {
            label: 'Our Data',
            link: ROUTES.OUR_DATA,
          },
          {
            label: 'Privacy center',
            link: ROUTES.PRIVACY_CENTER,
          },
          {
            label: 'Contact us',
            link: ROUTES.CONTACT_US,
          },
        ],
      },
      {
        label: 'Resources',
        children: [
          {
            label: 'Success Stories',
            link: ROUTES.SUCCESS_STORIES,
          },
          {
            label: 'Blog',
            link: '/blog',
          },
          {
            label: 'Help Center',
            link: EXTERNAL_ROUTES.HELP_CENTER,
          },
          {
            label: 'Become a Partner',
            link: ROUTES.CONTACT_US,
          },
        ],
      },
    ],
  };
};
